class cSlider {
    constructor(sliderContainer) {
        this.sliderContainer = document.querySelector(sliderContainer);
        if (!this.sliderContainer) {
            console.warn(`Slider container '${sliderContainer}' not found. Exiting.`);
            return;
        }
        
        this.slickSlider = this.sliderContainer.querySelector('.media-gallery-slider');
        if ( !this.slickSlider ){
            //this.slickSlider = [todo: later so we can init slick slider from here]
        }
        this.sliderThumbs = document.querySelectorAll('.media-gallery-thumbnail:not(.media-gallery-thumbnail-placeholder)');
        this.currentSlideIndex = 0; // Track current active slide

        this.init();
    }

    init() {
        if (this.sliderThumbs.length > 0) {
            this.sliderThumbs.forEach((thumb, index) => {
                thumb.addEventListener("click", (e) => {
                    e.stopPropagation();

                    if ( index === 4 ) {
                        tmPhotoGallery.showPhotoGalleryModal( 'provider-photos', index );	
                    }

                    this.updateActiveThumbnail(index);
                    this.goToSlide(index);
                });
            });

         

            // Event listener to update currentSlideIndex when slide changes
            window.jQuery(this.slickSlider).on('afterChange', (event, slick, currentSlide) => {
                this.currentSlideIndex = currentSlide;
                this.updateActiveThumbnail(currentSlide);
            });
        }
    }

    goToSlide(index) {
        if (window.jQuery && this.slickSlider) {
            let $slider = window.jQuery(this.slickSlider);
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('slickGoTo', index);
                this.currentSlideIndex = index; // Update active slide index
            } else {
                console.error("Slick is not initialized yet.");
            }
        } else {
            console.error("jQuery is not loaded or slick slider not found.");
        }
    }

    updateActiveThumbnail(index) {
        const activeThumb = this.sliderContainer.querySelector(".media-gallery-thumbnail-selected");
        if (activeThumb) {
            activeThumb.classList.remove("media-gallery-thumbnail-selected");
        }

        if (this.sliderThumbs[index]) {
            this.sliderThumbs[index].classList.add("media-gallery-thumbnail-selected");
        }
    }    
}
